import Image from "next/image";
import {Link} from "@/i18n/routing";

export default function LogoImage({ logoSrc, priority }) {
  return (
      <div className="site-logo">
        <Link href="/">
          {
            priority ? (
                <Image
                    src={logoSrc}
                    alt="Logo"
                    width={155}
                    height={50}
                    priority
                    style={{height: 'auto', aspectRatio: 155/50, objectFit: 'contain'}}
                />
            ) : (
                <Image
                    src={logoSrc}
                    alt="Logo"
                    width={155}
                    height={50}
                    loading="lazy"
                    style={{height: 'auto', aspectRatio: 155/50, objectFit: 'contain'}}
                />
            )
          }
        </Link>
      </div>
  );
};
